import { Client } from "./_clientService";

export async function getQuickBets(params: any) {
  let sortDir = "DESC";

  if (params.sortDir) sortDir = params.sortDir.toUpperCase();

  let payload = {
    sortDir,
    pageNo: params.pageNo ?? 1,
    limit: params.pageSize ?? 10,
    sortKey: params.sortKey ?? "createdAt",
    search: params.searchValue ?? "",
    skipPagination: params.skipPagination ?? false,
  };

  const resp = await new Client({ path: "/quick-bet/list", payload }).post();

  return resp;
}

export async function createQuickBet(payload: any) {
  const resp = await new Client({
    path: "/quick-bet/create",
    payload,
  }).post();
  return resp;
}

export async function updateQuickBet(payload: any) {
  const resp = await new Client({
    path: "/quick-bet/update",
    payload,
  }).post();
  return resp;
}

export async function getQuickBetInfo(quickBetId: any) {
  const resp = await new Client({
    path: "/quick-bet/info",
    payload: { quickBetId },
  }).post();
  return resp;
}

export async function deleteQuickBet(quickBetId: any) {
  const resp = await new Client({
    path: "/quick-bet/delete",
    payload: { quickBetId },
  }).post();
  return resp;
}
